export interface IUiStyle {
  id: number;
  menuMode: string;
  colorScheme: string;
  inputStyle: string;
  ripple: boolean;
  menuTheme: string;
  filterMode: string;
  reportLayout: string;
  componentTheme: string;
  overlayMenuActive: boolean;
  staticMenuMobileActive: boolean;
  staticMenuDesktopInactive: boolean;
}
